import { createContext } from 'react';
import firebase from 'firebase';

export interface Device {
  type: 'desktop' | 'phone';
  bigScreen: boolean;
}

export interface IContext {
  firebaseUser?: firebase.User;
  firebaseIdToken?: string;
  isAdmin: boolean;
  isClient: boolean;
  name?: string;
  clientId?: string;
  clientRole?: string;
  userId?: string;
  volcanoClientId?: string;
  device: Device;
  isPartOfDrivingCompany?: boolean;
  isDriver?: boolean;
}

const initialContext: IContext = {
  firebaseUser: undefined,
  firebaseIdToken: undefined,
  isAdmin: false,
  isClient: false,
  isPartOfDrivingCompany: false,
  isDriver: false,
  name: undefined,
  userId: undefined,
  volcanoClientId: undefined,
  device: {
    type: 'desktop',
    bigScreen: true,
  },
};

export const MainContext = createContext(initialContext);

export const MainConsumer = MainContext.Consumer;
